var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.header)?_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.header))])]):_vm._e(),_c('b-alert',{attrs:{"variant":_vm.alertType,"show":""}},[(_vm.message)?[_vm._v(_vm._s(_vm.message))]:[_vm._t("default")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }